import React, { useState } from 'react';

import { Steps } from 'antd';

import { Form, Formik } from 'formik';
import { PersonalDocumentType } from 'v2/components/Pages/AddBankAccount/Stepper/form';
import type { IBanklist, INewAccount, IOperationList } from 'v2/interfaces/financial';
import type { IProfile } from 'v2/interfaces/profile';

import BankReceipt from './BankReceipt';
import { newAccount } from './formik';
import NavButtons from './NavButtons';
import NewAccountForm from './NewAccountForm';
import PersonalDocuments from './PersonalDocuments';
import Resume from './Resume';
import { getSchema } from './validation';

interface IProps {
  profile?: IProfile;
  banks: IBanklist[];
  operations: IOperationList[];
  isForeign?: boolean;
  isLoadingBanks: boolean;
  isLoadingOperations: boolean;
  hasVideo?: boolean;
  isRefundAccount?: boolean;
  onSubmit: (values: INewAccount) => void;
}

const createAccountSteps = [
  { title: 'Conta' },
  { title: 'Documentos' },
  { title: 'Comprovante Bancário' },
  { title: 'Resumo' }
];

const CreateBankAccountStepper = ({ profile, isForeign = false, hasVideo = true, onSubmit, ...props }: IProps) => {
  const [docType, setDocType] = useState<string>(PersonalDocumentType.CNH);
  const [activeStep, setActiveStep] = useState(0);
  const [mediaPreview, setMediaPreview] = useState({ imgDocCNH: '', imgDocCPF: '', imgDocRG: '', imgBankReceipt: '' });

  const initialValues: INewAccount = {
    ...newAccount,
    document_number: profile?.document_number || '',
    name: profile?.name || ''
  };

  const toggleDocType = () => {
    setDocType(docType === PersonalDocumentType.CNH ? 'RG/CPF' : 'CNH');
  };

  const handleMediaPreview = (name: string, preview: any) => {
    setMediaPreview({
      ...mediaPreview,
      [name]: preview
    });
  };

  const getStepContent = (activeStep: number) => {
    const screenSteps = {
      0: <NewAccountForm {...props} isForeign={isForeign} />,
      1: (
        <PersonalDocuments
          hasVideo={hasVideo}
          docType={docType}
          mediaPreview={mediaPreview}
          onChangeDocType={toggleDocType}
          setMediaPreview={handleMediaPreview}
        />
      ),
      2: <BankReceipt mediaPreview={mediaPreview} setMediaPreview={handleMediaPreview} />,
      3: <Resume />
    };

    return screenSteps[activeStep as keyof typeof screenSteps];
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const newAccountSchema = getSchema(isForeign);

  return (
    <Formik validationSchema={newAccountSchema} initialValues={initialValues} onSubmit={onSubmit}>
      <Form>
        <div className='py-8'>
          <Steps current={activeStep} items={createAccountSteps} />
        </div>

        {getStepContent(activeStep)}

        <div className='mt-6'>
          <NavButtons
            activeStep={activeStep}
            hasVideo={hasVideo}
            docType={docType}
            onBack={handleBack}
            onNext={handleNext}
          />
        </div>
      </Form>
    </Formik>
  );
};

export default CreateBankAccountStepper;
